import { useState, useCallback, useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import { env } from '../../constants'
import { ReactComponent as SvgEmail } from '../../images/svg/icon-email.svg'
import CopyText from '../../components/copy-text'

import { requestResendEmail, requestCheckTenantStatus } from './model'
import styles from './styles.module.css'

const Welcome = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [resendMessage, setResendMessage] = useState()
  const [resendError, setResendError] = useState()

  const checkTenantStatus = useCallback((regtoken, workspaceUrl) => {
    const request = () => {
      const loop = () => {
        setTimeout(() => {
          request()
        }, 1000)
      }

      requestCheckTenantStatus(regtoken)
        .then(response => {
          if (response.status === 2 || response.status === 3) {
            const searchParams = new URLSearchParams()
            searchParams.set('regtoken', regtoken)
            searchParams.set('workspace_url', workspaceUrl)

            console.log(searchParams.get('workspace'))
            navigate(`/confirm?${searchParams.toString()}`, { replace: true })
          } else {
            loop()
          }
        })
        .catch((e) => {
          console.error(e.message)
          loop()
        })
    }

    request()
  }, [navigate])

  const handleResendEmail = () => {
    const token = searchParams.get('token')

    setResendMessage(null)
    setResendError(null)
    if (typeof token === 'string' && token.length > 0) {
      requestResendEmail(token)
        .then(() => {
          setResendMessage('The email has been sent, please check it.')
        })
        .catch(e => {
          setResendError(e.message)
        })
    } else {
      setResendError('Token lost.')
    }
  }

  useEffect(() => {
    const token = searchParams.get('token')
    const workspace = searchParams.get('workspace')

    if (typeof token === 'string' && token.length > 0) {
      checkTenantStatus(token, `https://${workspace}.${env.RUNTIME_DOMAIN}`)
    } else {
      setResendError('Token lost.')
    }
  }, [checkTenantStatus, searchParams])

  return (
    <div className={styles.wrapper}>
      <div className={styles.email_logo}>
        <SvgEmail />
      </div>
      <h1 className={styles.title}>Email Confirmation</h1>
      <div className={styles.content}>
        <p>Follow the link in the email we sent to <a className="word-break" href={`mailto://${searchParams.get('email')}`}>{searchParams.get('email')}</a> to verify your email and continue your registration.</p>
        <p>
          <CopyText text={`https://${searchParams.get('workspace')}.${env.RUNTIME_DOMAIN}`}>
            <strong>Your new workspace is at <span className="word-break">{`https://${searchParams.get('workspace')}.${env.RUNTIME_DOMAIN}`}</span></strong>
          </CopyText>
        </p>
        <div className={styles.divider} />
        <p>Did not receive the email? Check your spam folder or click the <b>Resend Email</b> button.</p>
      </div>
      <div className={styles.toast_wrapper}>
        {searchParams.has('token') && <button className={styles.resend_email} onClick={handleResendEmail}>Resend Email</button>}
        {resendMessage && <span className={styles.message}>{resendMessage}</span>}
        {resendError && <span className={classNames(styles.message, styles.error)}>{resendError}</span>}
      </div>
      <div className={styles.copyright}>
        <p>{`© ${new Date().getFullYear()} Splashtop`}</p>
      </div>
    </div>
  )
}

export default Welcome
